(function() {
    var optionCollapsible = null;

    addEventListener("DOMContentLoaded", (event) => {
        let submenuCollapsible = document.getElementsByClassName('shopify-section--submenu')[0];
        let itemsLinksCollapsible = null;

        let accordionProduct = document.getElementsByClassName('accordion-box');
        let faqSection = document.getElementsByClassName('shopify-section--faq');
        let faqsIdSection = '';

        
        if(document.getElementById('faqsIdSection')) {
            faqsIdSection = document.getElementById('faqsIdSection').value;

            if(faqsIdSection) {
                if (submenuCollapsible) {
                    itemsLinksCollapsible = document.getElementsByClassName('link-collapsible');
    
                    for (let i = 0; i < itemsLinksCollapsible.length; i++) {
                        itemsLinksCollapsible[i].href = `#${faqsIdSection}-item-${i+1}`;
    
                        itemsLinksCollapsible[i].addEventListener('click', (event) => {
                            itemDropdown().then(() => {
                                optionCollapsible = document.getElementById(`${faqsIdSection}-item-${i + 1}`);
        
                                optionCollapsible.ariaExpanded = "true";
                                optionCollapsible.style.overflow = "visible";
                                optionCollapsible.style.height = "auto";
                                optionCollapsible.setAttribute('open', '');
        
                                let contentOption = optionCollapsible.getElementsByClassName('accordion__content')[0];
    
                                contentOption.style.opacity = 1;
                                contentOption.style.transform = 'translateY(-4px)';
                            });
                        });
                    }
                }
            }
        }
    });

    function itemDropdown() {
        return new Promise((resolve, reject) => {
            let accordionItemsOption = document.getElementsByClassName('accordion-item');
    
            for (let i = 0; i < accordionItemsOption.length; i++) {
                const element = accordionItemsOption[i];
                accordionItemsOption[i].ariaExpanded = "false";
                accordionItemsOption[i].removeAttribute('open');
    
            }
            resolve();
        });
    }
})()